import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchSilosGrid({ silosParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `Dashboards/silos/${silosParams.factoryId}/${silosParams.groupId}`,
    });
    const silosGrid = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSilosGrid({ silosGrid }));
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_SILOS_GRID, fetchSilosGrid)]);
}
